export default "__VITE_ASSET__CkGBhi_l__"